import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    Adelantos: [],
};

export const registroAdelantosSlice = createSlice({
    name: "Adelantos",
    initialState,
    reducers: {
        agregarAdelanto: (state, action) => {
            if (Array.isArray(action.payload)) {
                state.Adelantos.push(...action.payload);
            } else {
                state.Adelantos.push(action.payload);
            }
        },
        modificarAdelanto: (state, action) => {
            const adelantoToUpdate = state.Adelantos.find(a => a.id ===action.payload.id);
            if (adelantoToUpdate) {
                Object.assign(adelantoToUpdate, action.payload);
            }
        },
    }
});

export const { agregarAdelanto, modificarAdelanto } = registroAdelantosSlice.actions;

export default registroAdelantosSlice.reducer;
